export class ViewModel {
  constructor(params, element) {
    this.subscriptions = [];
  }

  dispose() {
    this.subscriptions.forEach(s => s.dispose());
  }
}
